import { fingerprint } from "./fingerprint.js";
import { ARMS } from "./playbook.js";
export { GAP_CLOSEABLE_STEPS, REENGAGE_QUIET_DAYS, REPORTED_STRAIN_HIGH, STREAK_SAVE_SHORTFALL_STEPS, } from "./arm-reads.js";
export * from "./arm-types.js";
export { ARMS } from "./playbook.js";
export const ARM_ROWS = ARMS;
const BY_CAPABILITY = new Map(ARM_ROWS.map((a) => [a.capability, a]));
const BY_ACTION = new Map(ARM_ROWS.map((a) => [a.action, a]));
export function armFor(capability) {
    const arm = BY_CAPABILITY.get(capability);
    if (!arm)
        throw new Error(`unknown capability ${capability}`);
    return arm;
}
/** The arm an id names, or null once the library has dropped it. */
export function armSpec(action) {
    return BY_ACTION.get(action) ?? null;
}
/**
 * The version of a play's ask, as a fingerprint of its template copy: title,
 * body and the primary action label. Two decision points with the same
 * fingerprint offered the same words, so an edit to any of the three starts a
 * new variant without anyone having to remember to bump a number.
 */
export function templateFingerprint(arm) {
    const t = arm.template;
    return fingerprint(`${t.title}\n${t.body}\n${t.primaryLabel}`);
}
export const WATCHED_PILLARS = new Set(ARM_ROWS.map((a) => a.pillar));
/** When the observation window closes for a decision point taken at `at`. The calendar arms override this with the slot itself. */
export function windowEndsAt(spec, at) {
    return new Date(at.getTime() + spec.windowMinutes * 60_000);
}
/** When the card stops being worth showing for a decision point taken at `at`. */
export function offerExpiresAt(spec, at) {
    return new Date(at.getTime() + (spec.offerMinutes ?? spec.windowMinutes) * 60_000);
}
//# sourceMappingURL=arms.js.map